import { REDUX_CLASS_NAME_TO_DOMAIN } from 'modules/redux/constants'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import getDomainMapKeyFromPathReduxUtil from 'modules/redux/utils/get-domain-map-key-from-path'
import { getSectionNameFromClassNameModelUtil } from 'models/utils/get-section-name'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import { isLoadedReduxUtil } from 'modules/redux/utils/legacy/is-loaded'
import { isFakeModelUtil } from 'models/utils/is-fake'
import { getObjectUtil } from 'packages/src'

/**
 * Gets the domain name from the given className.
 * @param  {string} className
 * @param  {Instance} [associatedInstance]
 * @returns {string}
 */
function getDomainPath (className, associatedInstance) {
  if (className === CATEGORY_MODEL_CLASS_NAME && associatedInstance) {
    const section = getSectionNameFromClassNameModelUtil(associatedInstance.className)
    return `${REDUX_CLASS_NAME_TO_DOMAIN[className]}.${section}`
  }
  return REDUX_CLASS_NAME_TO_DOMAIN[className]
}

function getDomainMapKeyFromClassName (className, domainPath) {
  domainPath = domainPath || getDomainPath(className)
  return getDomainMapKeyFromPathReduxUtil(domainPath)
}

function getDomainMapValueReduxUtil (instance, domainPath) {
  const domainMapKey = getDomainMapKeyFromClassName(instance.className, domainPath)
  return (
    (
      (
        !isNewReduxUtil(instance) ||
        isLoadedReduxUtil(instance) ||
        isFakeModelUtil(instance)
      ) &&
      getObjectUtil(instance, `data.${domainMapKey}`)
    ) ||
    getIdReduxUtil(instance)
  )
}

export {
  getDomainMapValueReduxUtil
}
